import React from "react";
import classes from './Accordion.module.css'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const Element = (props) => {
    return (
        <Accordion expanded={props.isExpanded} onChange={props.clickAccordion}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.heading}/>}
                aria-controls="panel2a-content"
                id="panel2a-header"
                className={classes.Accordion}
            >
                <div className={classes.heading}>
                    <h3><strong>{props.title}</strong></h3>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <div className={classes.maxWidth}>
                    {props.children}
                </div>
            </AccordionDetails>
        </Accordion>
    );

};

export default Element;
